import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <div className="header-content">
        <div className="logo">
          <Link to="/">
            <img src="/images/logo64.png" alt="南京棱讯" />
            <span className="company-name">棱讯</span>
          </Link>
        </div>
        <nav className="nav-menu">
          <ul>
            <li><Link to="/">首页</Link></li>
            <li><Link to="/products">产品中心</Link></li>
            {/* <li><Link to="/solutions">解决方案</Link></li> */}
            {/* <li><Link to="/cases">客户案例</Link></li> */}
            <li><Link to="/about">关于棱讯</Link></li>
          </ul>
        </nav>
        {/* <div className="search-btn">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
        </div> */}
      </div>
    </header>
  );
};

export default Header;